import { render, staticRenderFns } from "./folder_editor.vue?vue&type=template&id=6adc5cde&"
import script from "./folder_editor.vue?vue&type=script&lang=js&"
export * from "./folder_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports